module.exports = __webpack_public_path__ + "img/index.3d5590d6.png";